export const table_GroupBorders = "$gUGkc";
export const report_GroupButton = "GP6Bfd";
export const teamsChat_Group = "kM5KGe";
export default {table_GroupBorders,report_GroupButton,teamsChat_Group};